import React from 'react';
import location from '../../../assets/images/location.svg';
import Image from '../../atoms/Image/Image';
const Address = () => {
    return (
        <>
            <div className='contact-info'>
                <figure><Image src={location} alt="Location" /></figure>
                <div>
                    <h3 className='h4'>Europcar India:</h3>
                    <p className='mb-0'>FF 114, Jmd Regent Square, Mall, Mehrauli-Gurgaon Rd, DLF Phase 2, Sector 25, Gurugram, Sarhol, Haryana 1220</p>
                </div>
            </div>
        </>
    )
}
export default Address